<div class="relative py-14 overflow-hidden bg-gray-900 rounded-b-3xl shadow-subtle mb-6">
      <!-- Background Image -->
      <div class="absolute inset-0 z-0">
            <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
                  alt="Broker Dashboard Background" class="w-full h-full object-cover">
            <!-- Overlay to blend with design system -->
            <div class="absolute inset-0 bg-gradient-to-r from-[#250701]/95 via-[#250701]/80 to-[#E45705]/40 mix-blend-multiply"></div>
            <div class="absolute inset-0 bg-black/30"></div>
      </div>

      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div class="flex flex-col md:flex-row items-center justify-between gap-6">

                  <!-- Text -->
                  <div>
                        <div class="flex items-center gap-3 mb-2">
                              <div class="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                                    <i class="fas text-white text-lg" [class.fa-building]="isBrokerCompany" [class.fa-briefcase]="!isBrokerCompany"></i>
                              </div>
                              <span class="text-white/80 text-sm font-medium uppercase tracking-wider">{{
                                    portalTitleKey | translate }}</span>
                        </div>
                        <h1 class="text-3xl font-bold text-white mb-2">{{ 'brokerDashboard.header.welcomeBack' |
                              translate }}</h1>
                        <p class="text-white/70 text-sm max-w-md">
                              {{ 'brokerDashboard.header.subtitle' | translate }}
                        </p>
                  </div>

                  <!-- Stats pills -->
                  <div class="flex flex-wrap gap-3">
                        <div
                              class="flex items-center gap-2 bg-white/15 backdrop-blur-sm px-4 py-2.5 rounded-xl border border-white/20">
                              <i class="fas fa-users text-white/80 text-sm"></i>
                              <span class="text-white text-sm font-medium">{{ 'brokerDashboard.header.clients' |
                                    translate }}</span>
                        </div>
                        <div
                              class="flex items-center gap-2 bg-white/15 backdrop-blur-sm px-4 py-2.5 rounded-xl border border-white/20">
                              <i class="fas fa-handshake text-white/80 text-sm"></i>
                              <span class="text-white text-sm font-medium">{{ 'brokerDashboard.header.deals' | translate
                                    }}</span>
                        </div>
                        <div
                              class="flex items-center gap-2 bg-white/15 backdrop-blur-sm px-4 py-2.5 rounded-xl border border-white/20">
                              <i class="fas fa-building text-white/80 text-sm"></i>
                              <span class="text-white text-sm font-medium">{{ 'brokerDashboard.header.units' | translate
                                    }}</span>
                        </div>
                  </div>

            </div>
      </div>
</div>